module.exports = __webpack_public_path__ + "img/header-page-info.4a9caf9d.png";